import React, { useEffect, useState } from "react";
import { Select, Radio, Space } from "antd";
import { fixedSelectCheck } from "./fixed-select-check";

const FixedSelectInput = ({
  valueSpec,
  onChange,
  onError,
  useBiToggle = false,
  multiSelect = false,
}) => {
  const [value, setValue] = useState(multiSelect ? [] : null);
  const [error, setError] = useState(null);
  const [enums, setEnums] = useState([]);

  useEffect(() => {
    setValue(valueSpec.value);
    setEnums(valueSpec.enums || []);
    const err = checkValue(valueSpec.value, valueSpec);
    if (err) {
      setError(true);
      onError(true);
    }
    return () => {};
  }, [valueSpec]);

  const handleToggle = (e, v) => {
    const err = checkValue(v, valueSpec);
    setValue(v);
    setError(err);
    onChange(v);
    onError(err);
  };

  const checkValue = (value, spec) => {
    if (multiSelect) {
      for (let i = 0; i < value.length; i++) {
        const err = !fixedSelectCheck(value[i], spec);
        if (err) {
          return err;
        }
      }
      return false;
    } else {
      const err = !fixedSelectCheck(value, spec);
      return err;
    }
  };

  const handleChange = value => {
    const err = !fixedSelectCheck(value, valueSpec);
    setValue(value);
    setError(err);
    onChange(value);
    onError(err);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        {valueSpec.name && (
          <div style={{ fontSize: "1rem", fontWeight: 600 }}>
            {valueSpec.name}
          </div>
        )}
        {useBiToggle && !multiSelect && enums.length === 2 ? (
          <Radio.Group
            value={value}
            onChange={e => handleToggle(null, e.target.value)}
            style={{ width: "100%" }}
          >
            <Radio.Button
              value={valueSpec.enums[0]}
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              {valueSpec.enums[0]}
            </Radio.Button>
            <Radio.Button
              value={valueSpec.enums[1]}
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              {valueSpec.enums[1]}
            </Radio.Button>
          </Radio.Group>
        ) : (
          <>
            {value !== null && (
              <Select
                placeholder="Select an Option"
                value={multiSelect ? value : value || undefined}
                onChange={handleChange}
                mode={multiSelect ? "multiple" : undefined}
                status={error ? "error" : ""}
                style={{ width: "100%" }}
              >
                {enums.map(option => (
                  <Select.Option key={option} value={option}>
                    {option}
                  </Select.Option>
                ))}
              </Select>
            )}
          </>
        )}
      </Space>
    </div>
  );
};

export default FixedSelectInput;
